import "./Input.css";
import { useState } from "react";
import { forwardRef } from "react";

const TextInput = forwardRef(({ className = 'full-width input-space', type = 'text', autoComplete = 'chrome-off', value, ...rest }, ref) => {
    const prefixeClassName = "input";
    const [passwordShown, setPasswordShown] = useState(false);
    const togglePassword = () => {
        setPasswordShown(!passwordShown);
    };
    return (
        <>
            {type == "password" ? (
                <div style={{ display: "flex" }}>
                    <input
                        {...rest}
                        ref={ref}
                        type={type == "password" ? (passwordShown ? "text" : "password") : type}
                        value={value}
                        className={
                            prefixeClassName +
                            (className ? " " + className : "") +
                            (type == "password" ? " input_auth" : "")
                        }></input>
                    <i
                        className={"icon_toggle_password " + (passwordShown ? "fas fa-eye-slash" : "fas fa-eye")}
                        onClick={() => togglePassword()}></i>
                </div>
            ) : (
                <input
                    {...rest}
                    ref={ref}
                    value={value}
                    className={prefixeClassName + (className ? " " + className : "")}></input>
            )}
        </>
    );
});

export default TextInput;
